/* Zen Garden — Shopify bundle (auto-generated) */
(function () {
  function boot() {

/* ===== noise.js ===== */
/**
 * Lightweight value-noise helpers for sand grain.
 * Deterministic, allocation-light — good for baking a texture once.
 */

function fade(t) {
  return t * t * (3 - 2 * t);
}

function lerp(a, b, t) {
  return a + (b - a) * t;
}

/** Integer hash → [0, 1) */
function hash2(x, y, seed = 0) {
  let n = x * 374761393 + y * 668265263 + seed * 982451653;
  n = (n ^ (n >>> 13)) * 1274126177;
  n = n ^ (n >>> 16);
  return (n >>> 0) / 4294967296;
}

/**
 * Smooth 2D value noise in [0, 1].
 */
function valueNoise2D(x, y, seed = 0) {
  const x0 = Math.floor(x);
  const y0 = Math.floor(y);
  const xf = fade(x - x0);
  const yf = fade(y - y0);

  const v00 = hash2(x0, y0, seed);
  const v10 = hash2(x0 + 1, y0, seed);
  const v01 = hash2(x0, y0 + 1, seed);
  const v11 = hash2(x0 + 1, y0 + 1, seed);

  return lerp(lerp(v00, v10, xf), lerp(v01, v11, xf), yf);
}

/**
 * Fractal Brownian motion — layered grain for sand.
 */
function fbm2D(x, y, { octaves = 4, lacunarity = 2, gain = 0.5, seed = 0 } = {}) {
  let amp = 0.5;
  let freq = 1;
  let sum = 0;
  let norm = 0;
  for (let i = 0; i < octaves; i++) {
    sum += amp * valueNoise2D(x * freq, y * freq, seed + i * 101);
    norm += amp;
    amp *= gain;
    freq *= lacunarity;
  }
  return sum / norm;
}


/* ===== config.js ===== */
/**
 * Brand & experience — matched to crmny. design comps.
 */
const brand = {
  eyebrow: 'Zen Garden',
  name: 'crmny.',
  practice: 'take a moment for yourself. use the zen tools to find your flow.',
  directions: 'tap the tool that calls to you, and glide it gently over the sand.',
  ctaLabel: 'Enter site >',
  ctaHref: 'https://ceremonymatcha.co.za/',
  smoothLabel: 'Smooth the surface',
};

const palette = {
  // Lighter sand bed matching comps
  sandLight: '#F4EDE3',
  sandMid: '#E6D9C6',
  sandDark: '#C9B59A',
  sandWarm: '#EEDCC2',
  sandCool: '#D8CBB8',
  // Beach / moss-garden pebble tones
  stoneLight: '#D8C8B4',
  stoneMid: '#A89178',
  stoneDark: '#5E4B3A',
  stoneFleck: '#746150',
  stoneMoss: '#8A7B62',
  panel: '#F7F4EE',
  ink: '#1A1814',
};

/** Light direction for groove shading. */
const lighting = {
  lx: -0.55,
  ly: -0.72,
};

/**
 * Garden stones — your uploaded pebbles (css fractions of canvas).
 * r = collision / shadow radius; image sized to ~2.2r across.
 */
const stones = [
  { cx: 0.2, cy: 0.28, r: 0.1, image: (window.ZEN_ASSETS && window.ZEN_ASSETS.stoneBanded) || 'assets/stones/stone-banded.png' },
  { cx: 0.82, cy: 0.62, r: 0.075, image: (window.ZEN_ASSETS && window.ZEN_ASSETS.stoneLight) || 'assets/stones/stone-light.png' },
  { cx: 0.55, cy: 0.78, r: 0.07, image: (window.ZEN_ASSETS && window.ZEN_ASSETS.stoneDark) || 'assets/stones/stone-dark.png' },
];

const experience = {
  ctaDelayMs: 1400,
  /** Pressure response: slow drag = deeper; touch force when available */
  pressure: {
    /** px/ms at which stroke is considered "fast" (shallow) */
    fastSpeed: 1.6,
    /** px/ms at which stroke is considered "slow" (deep) */
    slowSpeed: 0.08,
    min: 0.28,
    max: 1.05,
  },
  settle: {
    enabled: true,
    ratePerSecond: 0.00025,
    idleDelayMs: 12000,
  },
  /** Desktop stroke size slider (Instagram-style). 1 = previous default. */
  brushSize: {
    min: 0.7,
    max: 2.2,
    default: 1.35,
  },
};


/* ===== tools.js ===== */
/**
 * Wooden rake tools — distinct groove patterns.
 */

/**
 * @typedef {Object} ToolDef
 * @property {string} id
 * @property {string} label
 * @property {string} image
 * @property {'rake'|'smooth'} mode
 * @property {number[]} [offsets]
 * @property {number} [width]
 * @property {number} [depth]
 * @property {number} [smoothRadius]
 * @property {boolean} [ignorePressure] - keep a consistent, readable pattern
 * @property {number} [pressureFixed] - used when ignorePressure is true
 */

/** @type {ToolDef[]} */
const tools = [
  {
    id: 'long',
    label: 'Long-tine rake',
    image: (window.ZEN_ASSETS && window.ZEN_ASSETS.rakeLong) || 'assets/tools/rake-long.png',
    mode: 'rake',
    offsets: [-24, -12, 0, 12, 24],
    width: 3.4,
    depth: 0.74,
  },
  {
    id: 'smooth',
    label: 'Smoothing paddle',
    image: (window.ZEN_ASSETS && window.ZEN_ASSETS.smoother) || 'assets/tools/smoother.png',
    mode: 'smooth',
    // Wide enough that ~3 overlapping passes clear a groove
    smoothRadius: 62,
    smoothStrength: 0.62,
  },
  {
    id: 'scalloped',
    label: 'Wide rake',
    image: (window.ZEN_ASSETS && window.ZEN_ASSETS.rakeScalloped) || 'assets/tools/rake-scalloped.png',
    mode: 'rake',
    // Four clear, separated furrows — readable at any speed/pressure
    offsets: [-26, -9, 9, 26],
    width: 2.6,
    depth: 0.42,
    ignorePressure: true,
    pressureFixed: 0.88,
  },
];

function getToolById(id) {
  return tools.find((t) => t.id === id) || tools[0];
}


/* ===== audio.js ===== */
/**
 * Ambient audio — procedural brown noise + soft sand scrape.
 * iOS: keep buffer generation short and resume AudioContext inside the tap.
 */

/** Optional: set to a URL string to use a looping file instead. */
const brandAudioUrl = null; // e.g. 'assets/brown-noise.mp3'

class GardenAudio {
  constructor() {
    /** @type {AudioContext|null} */
    this.ctx = null;
    this.master = null;
    this.ambientGain = null;
    this.scrapeGain = null;
    this.enabled = false;
    this._scrapeLast = 0;
    this._usingFile = false;
    this._fileEl = null;
    this._ambientStarted = false;
    this._scrapeStarted = false;
    this._noiseSource = null;
  }

  async toggle() {
    if (!this.enabled) {
      await this.enable();
    } else {
      this.disable();
    }
    return this.enabled;
  }

  /** Call from any user gesture to unlock iOS audio. */
  async unlock() {
    try {
      if (!this.ctx) {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        this.ctx = new Ctx();
      }
      if (this.ctx.state === 'suspended') {
        await this.ctx.resume();
      }
    } catch {
      /* ignore */
    }
  }

  async enable() {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;

    if (!this.ctx) {
      this.ctx = new Ctx();
      this.master = this.ctx.createGain();
      // Slightly louder on phones — speakers + silent-switch quirks
      const mobile = window.matchMedia('(pointer: coarse)').matches;
      this.master.gain.value = mobile ? 0.85 : 0.62;
      this.master.connect(this.ctx.destination);

      this.ambientGain = this.ctx.createGain();
      this.ambientGain.gain.value = 0;
      this.ambientGain.connect(this.master);

      this.scrapeGain = this.ctx.createGain();
      this.scrapeGain.gain.value = 0;
      this.scrapeGain.connect(this.master);
    }

    // Must resume inside the tap gesture before heavy work
    if (this.ctx.state === 'suspended') {
      await this.ctx.resume();
    }

    if (brandAudioUrl) {
      await this._startFileAmbient(brandAudioUrl);
    } else {
      this._startBrownNoise();
    }
    this._startScrapeNoise();

    // Re-resume after buffer build (iOS can suspend again)
    if (this.ctx.state === 'suspended') {
      await this.ctx.resume();
    }

    const now = this.ctx.currentTime;
    const target = window.matchMedia('(pointer: coarse)').matches ? 0.48 : 0.34;
    this.ambientGain.gain.cancelScheduledValues(now);
    this.ambientGain.gain.setValueAtTime(this.ambientGain.gain.value, now);
    this.ambientGain.gain.linearRampToValueAtTime(target, now + 1.4);

    this.enabled = true;
  }

  disable() {
    if (!this.ctx || !this.ambientGain) {
      this.enabled = false;
      return;
    }
    const now = this.ctx.currentTime;
    this.ambientGain.gain.cancelScheduledValues(now);
    this.ambientGain.gain.setValueAtTime(this.ambientGain.gain.value, now);
    this.ambientGain.gain.linearRampToValueAtTime(0, now + 0.7);
    this.scrapeGain.gain.setTargetAtTime(0, now, 0.05);

    if (this._fileEl) {
      this._fileEl.pause();
    }
    this.enabled = false;
  }

  scrape(speed) {
    if (!this.enabled || !this.ctx || !this.scrapeGain) return;
    if (this.ctx.state === 'suspended') {
      this.ctx.resume().catch(() => {});
    }
    const now = this.ctx.currentTime;
    if (now - this._scrapeLast < 0.032) return;
    this._scrapeLast = now;
    const target = clamp(speed / 28, 0, 1) * 0.07;
    this.scrapeGain.gain.setTargetAtTime(target, now, 0.04);
    this.scrapeGain.gain.setTargetAtTime(0, now + 0.08, 0.08);
  }

  async _startFileAmbient(url) {
    if (this._usingFile && this._fileEl) {
      try {
        await this._fileEl.play();
      } catch {
        /* ignore */
      }
      return;
    }
    const el = new Audio(url);
    el.loop = true;
    el.playsInline = true;
    el.crossOrigin = 'anonymous';
    const src = this.ctx.createMediaElementSource(el);
    src.connect(this.ambientGain);
    this._fileEl = el;
    this._usingFile = true;
    await el.play();
  }

  /** True brown noise — deep, soft, continuous. */
  _startBrownNoise() {
    if (this._ambientStarted || !this.ctx) return;
    this._ambientStarted = true;
    const ctx = this.ctx;

    // Keep short so iOS still treats this as part of the user gesture
    const bufferSize = Math.max(1, Math.floor(ctx.sampleRate * 1.25));
    const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    const data = buffer.getChannelData(0);

    let last = 0;
    for (let i = 0; i < bufferSize; i++) {
      const white = Math.random() * 2 - 1;
      last = (last + 0.02 * white) / 1.02;
      data[i] = last * 3.8;
    }

    let peak = 0.0001;
    for (let i = 0; i < bufferSize; i++) {
      const a = Math.abs(data[i]);
      if (a > peak) peak = a;
    }
    const inv = 0.9 / peak;
    for (let i = 0; i < bufferSize; i++) {
      data[i] *= inv;
    }

    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    noise.loop = true;

    const low = ctx.createBiquadFilter();
    low.type = 'lowpass';
    low.frequency.value = 220;
    low.Q.value = 0.55;

    const highCut = ctx.createBiquadFilter();
    highCut.type = 'lowpass';
    highCut.frequency.value = 480;
    highCut.Q.value = 0.4;

    const brownGain = ctx.createGain();
    brownGain.gain.value = 1;

    noise.connect(low);
    low.connect(highCut);
    highCut.connect(brownGain);
    brownGain.connect(this.ambientGain);
    noise.start();
    this._noiseSource = noise;
  }

  _startScrapeNoise() {
    if (this._scrapeStarted || !this.ctx) return;
    this._scrapeStarted = true;
    const ctx = this.ctx;
    const bufferSize = Math.max(1, Math.floor(ctx.sampleRate * 0.5));
    const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < bufferSize; i++) {
      data[i] = Math.random() * 2 - 1;
    }
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    src.loop = true;
    const bp = ctx.createBiquadFilter();
    bp.type = 'bandpass';
    bp.frequency.value = 1400;
    bp.Q.value = 0.55;
    src.connect(bp);
    bp.connect(this.scrapeGain);
    src.start();
  }
}

function clamp(v, a, b) {
  return Math.max(a, Math.min(b, v));
}


/* ===== sand-engine.js ===== */
/**
 * Sand garden engine — height-field grooves + shaded canvas render.
 * Uses HTML5 Canvas 2D; pointer paths are spline-smoothed for calm strokes.
 */

function hexToRgb(hex) {
  const h = hex.replace('#', '');
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

function clamp(v, a, b) {
  return Math.max(a, Math.min(b, v));
}

function hashJitter(x, y) {
  let n = x * 374761393 + y * 668265263;
  n = (n ^ (n >>> 13)) * 1274126177;
  return ((n >>> 0) % 1000) / 1000;
}

function dist(ax, ay, bx, by) {
  return Math.hypot(bx - ax, by - ay);
}

class SandEngine {
  /**
   * @param {HTMLCanvasElement} canvas
   * @param {{ onRake?: (speed: number) => void }} [hooks]
   */
  constructor(canvas, hooks = {}) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d', { alpha: false });
    this.hooks = hooks;

    this.dpr = 1;
    this.cssW = 0;
    this.cssH = 0;
    this.pxW = 0;
    this.pxH = 0;

    /** @type {Float32Array|null} */
    this.height = null;
    /** @type {Uint8ClampedArray|null} */
    this.grain = null;
    /** @type {{x:number,y:number,r:number}[]} css-space stones */
    this.stones = [];

    this.toolId = 'long';
    /** User stroke size multiplier (desktop slider). */
    this.brushSize = 1;
    this.drawing = false;
    this.pathLength = 0;
    this.lastPoint = null;
    this.needsFullRender = true;
    this.dirty = null;
    this.settleAcc = 0;
    this._lastTs = 0;
    this._grainSeed = 11;
    this._lastMoveTs = 0;
    this._strokePressure = 0.75;

    this.lastInteractAt = performance.now();
    this.rafId = 0;
    this.running = false;

    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp = this._onPointerUp.bind(this);
    this._loop = this._loop.bind(this);
  }

  setTool(id) {
    this.toolId = id;
  }

  setBrushSize(mul) {
    this.brushSize = clamp(mul, 0.5, 2.5);
  }

  _loadStoneImages() {
    if (!this._stoneImages) this._stoneImages = new Map();
    for (const def of stones) {
      if (!def.image || this._stoneImages.has(def.image)) continue;
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        this.needsFullRender = true;
      };
      img.src = def.image;
      this._stoneImages.set(def.image, img);
    }
  }

  mount() {
    this._loadStoneImages();
    this.resize();
    this.canvas.addEventListener('pointerdown', this._onPointerDown);
    window.addEventListener('pointermove', this._onPointerMove);
    window.addEventListener('pointerup', this._onPointerUp);
    window.addEventListener('pointercancel', this._onPointerUp);
    this.canvas.addEventListener(
      'touchmove',
      (e) => {
        if (this.drawing) e.preventDefault();
      },
      { passive: false }
    );
    this.running = true;
    this.rafId = requestAnimationFrame(this._loop);
  }

  unmount() {
    this.running = false;
    cancelAnimationFrame(this.rafId);
    this.canvas.removeEventListener('pointerdown', this._onPointerDown);
    window.removeEventListener('pointermove', this._onPointerMove);
    window.removeEventListener('pointerup', this._onPointerUp);
    window.removeEventListener('pointercancel', this._onPointerUp);
  }

  resize() {
    // Measure against the parent so iOS chrome size changes don't stretch the bitmap
    const parent = this.canvas.parentElement || this.canvas;
    this.canvas.style.width = '100%';
    this.canvas.style.height = '100%';
    const rect = parent.getBoundingClientRect();
    // Cap DPR — garden can be large; keep mid-range devices smooth
    const dpr = Math.min(window.devicePixelRatio || 1, 1.35);
    const cssW = Math.max(1, Math.round(rect.width));
    const cssH = Math.max(1, Math.round(rect.height));
    const pxW = Math.max(1, Math.round(cssW * dpr));
    const pxH = Math.max(1, Math.round(cssH * dpr));

    if (pxW === this.pxW && pxH === this.pxH && dpr === this.dpr) {
      this.canvas.style.width = `${cssW}px`;
      this.canvas.style.height = `${cssH}px`;
      return;
    }

    this.dpr = dpr;
    this.cssW = cssW;
    this.cssH = cssH;
    this.pxW = pxW;
    this.pxH = pxH;

    this.canvas.width = pxW;
    this.canvas.height = pxH;
    // Lock display size to the bitmap aspect (avoids warped stones on iPhone)
    this.canvas.style.width = `${cssW}px`;
    this.canvas.style.height = `${cssH}px`;

    this.ctx.fillStyle = palette.sandMid;
    this.ctx.fillRect(0, 0, pxW, pxH);

    // Cap stone size on narrow phones so they don't dominate / look stretched
    const stoneBase = Math.min(cssW, cssH);
    const stoneScale = cssW < 700 ? 0.78 : 1;
    this.stones = stones.map((s) => ({
      x: s.cx * cssW,
      y: s.cy * cssH,
      r: s.r * stoneBase * stoneScale,
      image: s.image || null,
    }));

    this.height = new Float32Array(pxW * pxH);
    this._fillCleanSand();
    this._bakeGrain();
    this.needsFullRender = true;
    this.dirty = null;
    this.settleAcc = 0;
  }

  /**
   * Shake the table — clears patterns back to a clean granular bed.
   * Re-bakes grain so the surface resettles with fresh speckles.
   */
  shake() {
    if (!this.height) return;
    this._grainSeed += 23;
    this._fillCleanSand();
    this._bakeGrain();
    this.lastInteractAt = performance.now();
    this.needsFullRender = true;
  }

  reset() {
    this.shake();
  }

  /** Flat bed with only micro-relief so lighting catches real grain. */
  _fillCleanSand() {
    const { height, pxW, pxH } = this;
    if (!height) return;
    const seed = this._grainSeed;
    for (let y = 0; y < pxH; y++) {
      for (let x = 0; x < pxW; x++) {
        // Tiny undulation only — never reads as raked lines
        const n =
          fbm2D(x * 0.018, y * 0.018, { octaves: 2, seed }) * 0.028 +
          (hashJitter(x + seed, y) - 0.5) * 0.012;
        height[y * pxW + x] = 0.5 + n;
      }
    }
  }

  _bakeGrain() {
    const { pxW, pxH } = this;
    const grain = new Uint8ClampedArray(pxW * pxH * 3);
    const base = hexToRgb(palette.sandMid);
    const light = hexToRgb(palette.sandLight);
    const dark = hexToRgb(palette.sandDark);
    const warm = hexToRgb(palette.sandWarm || palette.sandLight);
    const cool = hexToRgb(palette.sandCool || palette.sandDark);
    const seed = this._grainSeed;

    for (let y = 0; y < pxH; y++) {
      for (let x = 0; x < pxW; x++) {
        // Soft base variation
        const broad = fbm2D(x * 0.007, y * 0.007, { octaves: 3, seed });
        const clumps = fbm2D(x * 0.045, y * 0.045, { octaves: 3, seed: seed + 17 });
        // High-frequency grit — the "speckled sand" read
        const gritA = hashJitter(x * 3 + seed, y * 5);
        const gritB = hashJitter(x * 11 + 19, y * 7 + seed);
        const gritC = hashJitter(x + y * 3 + seed, x * 5 - y);
        const fine = fbm2D(x * 0.32, y * 0.32, { octaves: 2, seed: seed + 41 });
        const tint = fbm2D(x * 0.01, y * 0.012, { octaves: 2, seed: seed + 73 });

        let tone =
          (broad - 0.5) * 0.22 +
          (clumps - 0.5) * 0.28 +
          (fine - 0.5) * 0.35 +
          (gritA - 0.5) * 0.55 +
          (gritB - 0.5) * 0.4;

        let r = base.r + (tone >= 0 ? light.r - base.r : base.r - dark.r) * Math.abs(tone) * 1.35;
        let g = base.g + (tone >= 0 ? light.g - base.g : base.g - dark.g) * Math.abs(tone) * 1.35;
        let b = base.b + (tone >= 0 ? light.b - base.b : base.b - dark.b) * Math.abs(tone) * 1.25;

        // Warm / cool mineral patches
        const tw = (tint - 0.5) * 0.2;
        if (tw >= 0) {
          r += (warm.r - r) * tw;
          g += (warm.g - g) * tw;
          b += (warm.b - b) * tw;
        } else {
          const u = -tw;
          r += (cool.r - r) * u;
          g += (cool.g - g) * u;
          b += (cool.b - b) * u;
        }

        // Discrete sand grains — speckled dots of varying tone
        if (gritC > 0.9) {
          const bit = (gritC - 0.9) / 0.1;
          r -= 28 * bit;
          g -= 26 * bit;
          b -= 22 * bit;
        } else if (gritC < 0.08) {
          const bit = (0.08 - gritC) / 0.08;
          r += 22 * bit;
          g += 18 * bit;
          b += 12 * bit;
        }

        // Micro scatter so flat areas never feel digitally smooth
        const scatter = (gritB - 0.5) * 16;
        r += scatter;
        g += scatter * 0.92;
        b += scatter * 0.8;

        const i = (y * pxW + x) * 3;
        grain[i] = clamp(r, 0, 255);
        grain[i + 1] = clamp(g, 0, 255);
        grain[i + 2] = clamp(b, 0, 255);
      }
    }
    this.grain = grain;
  }

  _hitsStone(cssX, cssY, pad = 2) {
    for (const s of this.stones) {
      if (dist(cssX, cssY, s.x, s.y) < s.r + pad) return true;
    }
    return false;
  }

  _eventToLocal(e) {
    const rect = this.canvas.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  }

  _onPointerDown(e) {
    if (e.button != null && e.button !== 0) return;
    this.canvas.setPointerCapture?.(e.pointerId);
    const p = this._eventToLocal(e);
    if (this._hitsStone(p.x, p.y, 0)) return;
    this.drawing = true;
    this.lastPoint = p;
    this.pathLength = 0;
    this._lastMoveTs = performance.now();
    this._strokePressure = this._resolvePressure(e, 0.2);
    this.lastInteractAt = performance.now();
    e.preventDefault();
  }

  _onPointerMove(e) {
    if (!this.drawing || !this.lastPoint) return;
    const p = this._eventToLocal(e);
    const d = dist(this.lastPoint.x, this.lastPoint.y, p.x, p.y);
    if (d < 1.2) return;

    if (this._hitsStone(p.x, p.y, 2)) {
      this.lastPoint = p;
      return;
    }

    const now = performance.now();
    const dt = Math.max(1, now - (this._lastMoveTs || now));
    const speed = d / dt; // css px per ms
    this._lastMoveTs = now;
    this._strokePressure = this._resolvePressure(e, speed);

    const mid = {
      x: (this.lastPoint.x + p.x) * 0.5,
      y: (this.lastPoint.y + p.y) * 0.5,
    };
    this._strokeTo(mid);
    this._strokeTo(p);
    this.hooks.onRake?.(d);
    this.lastInteractAt = now;
    e.preventDefault();
  }

  /**
   * Map pointer force / drag speed → pressure multiplier.
   * iPhone touch often reports pressure as 0 or 1 (unsupported) — treat those
   * as fake and use drag speed instead, otherwise strokes get huge.
   */
  _resolvePressure(e, speedPxPerMs) {
    const cfg = experience.pressure || {};
    const minP = cfg.min ?? 0.28;
    const maxP = cfg.max ?? 1.05;
    const slow = cfg.slowSpeed ?? 0.08;
    const fast = cfg.fastSpeed ?? 1.6;

    const speedFactor = clamp(1 - (speedPxPerMs - slow) / Math.max(0.001, fast - slow), 0, 1);
    const fromSpeed = minP + speedFactor * (maxP - minP);

    const raw = typeof e.pressure === 'number' ? e.pressure : 0;
    // Real force is usually between the fake defaults (0 / 0.5 / 1)
    const hasForce =
      e.pointerType === 'pen' ||
      (e.pointerType === 'touch' && raw > 0.05 && raw < 0.98 && raw !== 0.5);

    if (hasForce) {
      const fromForce = minP + raw * (maxP - minP);
      return clamp(fromForce * 0.65 + fromSpeed * 0.35, minP, maxP);
    }

    return fromSpeed;
  }

  /** Scale tool geometry to canvas size (desktop-tuned values are too big on phones). */
  _toolScale() {
    const ref = 900;
    const size = Math.min(this.cssW || ref, this.cssH || ref);
    const fit = clamp(size / ref, 0.42, 1.05);
    return fit * (this.brushSize || 1);
  }

  _onPointerUp(e) {
    if (!this.drawing) return;
    this.drawing = false;
    this.lastPoint = null;
    this.lastInteractAt = performance.now();
    try {
      this.canvas.releasePointerCapture?.(e.pointerId);
    } catch {
      /* ignore */
    }
  }

  _strokeTo(p) {
    const tool = getToolById(this.toolId);
    const prev = this.lastPoint;
    if (!prev) {
      this.lastPoint = p;
      return;
    }
    const segLen = dist(prev.x, prev.y, p.x, p.y);
    const stepPx = tool.mode === 'smooth' ? 1.6 : 2.5;
    const steps = Math.max(1, Math.ceil(segLen / stepPx));
    for (let i = 1; i <= steps; i++) {
      const t = i / steps;
      const x = prev.x + (p.x - prev.x) * t;
      const y = prev.y + (p.y - prev.y) * t;
      const px = prev.x + (p.x - prev.x) * ((i - 1) / steps);
      const py = prev.y + (p.y - prev.y) * ((i - 1) / steps);
      if (tool.mode === 'smooth') {
        this._smoothAt(x, y, tool.smoothRadius || 20, tool.smoothStrength);
      } else {
        this._carveSegment(px, py, x, y, tool, this.pathLength);
      }
      this.pathLength += dist(px, py, x, y);
    }
    this.lastPoint = p;
  }

  _carveSegment(x0, y0, x1, y1, tool, pathLen) {
    if (this._hitsStone(x0, y0, 1) || this._hitsStone(x1, y1, 1)) return;

    const dx = x1 - x0;
    const dy = y1 - y0;
    const len = Math.hypot(dx, dy) || 1;
    const nx = -dy / len;
    const ny = dx / len;

    const pressure = tool.ignorePressure
      ? tool.pressureFixed ?? 0.88
      : this._strokePressure || 0.75;
    const dpr = this.dpr;
    const scale = this._toolScale();
    // Pressure can widen/deepen — but capped so grooves don't merge into mush
    const widthMul = tool.ignorePressure ? 1 : 0.62 + pressure * 0.45;
    const depthMul = tool.ignorePressure ? 1 : 0.45 + pressure * 0.55;
    const width = (tool.width || 1) * dpr * scale * widthMul;
    const depth = (tool.depth || 0.45) * depthMul;

    for (const offsetCss of tool.offsets || [0]) {
      const spread = tool.ignorePressure ? 1 : 0.9 + pressure * 0.12;
      const ox = offsetCss * scale * nx * spread;
      const oy = offsetCss * scale * ny * spread;
      const ax = (x0 + ox) * dpr;
      const ay = (y0 + oy) * dpr;
      const bx = (x1 + ox) * dpr;
      const by = (y1 + oy) * dpr;
      this._stampGroove(ax, ay, bx, by, width, depth, nx, ny);
    }
  }

  _smoothAt(cssX, cssY, radiusCss, strength = 0.62) {
    // Keep eraser usable on phones — don't shrink as hard as rake tines
    const scaledRadius = radiusCss * Math.max(0.72, this._toolScale());
    if (this._hitsStone(cssX, cssY, scaledRadius * 0.35)) return;
    const { pxW, pxH, height, dpr } = this;
    if (!height) return;

    const cx = cssX * dpr;
    const cy = cssY * dpr;
    const radius = scaledRadius * dpr;
    const xA = clamp(Math.floor(cx - radius), 0, pxW - 1);
    const xB = clamp(Math.ceil(cx + radius), 0, pxW - 1);
    const yA = clamp(Math.floor(cy - radius), 0, pxH - 1);
    const yB = clamp(Math.ceil(cy + radius), 0, pxH - 1);
    const blend = clamp(strength, 0.2, 0.9);

    for (let y = yA; y <= yB; y++) {
      for (let x = xA; x <= xB; x++) {
        const d = Math.hypot(x - cx, y - cy);
        if (d > radius) continue;
        // don't smooth under stones
        if (this._hitsStone(x / dpr, y / dpr, 0)) continue;
        const falloff = 1 - d / radius;
        const idx = y * pxW + x;
        // Soft edge, strong center — ~3 overlapping strokes flatten grooves
        height[idx] += (0.5 - height[idx]) * blend * falloff;
      }
    }
    this._markDirty(xA, yA, xB, yB);
  }

  _stampGroove(x0, y0, x1, y1, width, depth, nx, ny) {
    const { pxW, pxH, height, dpr } = this;
    if (!height) return;

    const minX = Math.floor(Math.min(x0, x1) - width * 3 - 2);
    const maxX = Math.ceil(Math.max(x0, x1) + width * 3 + 2);
    const minY = Math.floor(Math.min(y0, y1) - width * 3 - 2);
    const maxY = Math.ceil(Math.max(y0, y1) + width * 3 + 2);

    const xA = clamp(minX, 0, pxW - 1);
    const xB = clamp(maxX, 0, pxW - 1);
    const yA = clamp(minY, 0, pxH - 1);
    const yB = clamp(maxY, 0, pxH - 1);

    const sdx = x1 - x0;
    const sdy = y1 - y0;
    const slen2 = sdx * sdx + sdy * sdy || 1;

    for (let y = yA; y <= yB; y++) {
      for (let x = xA; x <= xB; x++) {
        if (this._hitsStone(x / dpr, y / dpr, 0)) continue;

        let t = ((x - x0) * sdx + (y - y0) * sdy) / slen2;
        t = clamp(t, 0, 1);
        const px = x0 + sdx * t;
        const py = y0 + sdy * t;
        const ddx = x - px;
        const ddy = y - py;
        const d = Math.hypot(ddx, ddy);
        if (d > width * 2.8) continue;

        const u = d / (width * 1.05);
        let delta = 0;
        if (u < 1) {
          delta = -depth * (1 - u * u);
        } else if (u < 2.8) {
          const r = (u - 1) / 1.8;
          delta = depth * 0.36 * (1 - r) * (1 - r);
        }

        const idx = y * pxW + x;
        // Keep ridges in sandy midtones — avoid blown-out white peaks
        height[idx] = clamp(height[idx] + delta * 0.78, 0.14, 0.72);
      }
    }

    this._markDirty(xA, yA, xB, yB);
  }

  _markDirty(x0, y0, x1, y1) {
    const pad = 2;
    const rect = {
      x0: Math.max(0, x0 - pad),
      y0: Math.max(0, y0 - pad),
      x1: Math.min(this.pxW - 1, x1 + pad),
      y1: Math.min(this.pxH - 1, y1 + pad),
    };
    if (!this.dirty) {
      this.dirty = rect;
      return;
    }
    this.dirty.x0 = Math.min(this.dirty.x0, rect.x0);
    this.dirty.y0 = Math.min(this.dirty.y0, rect.y0);
    this.dirty.x1 = Math.max(this.dirty.x1, rect.x1);
    this.dirty.y1 = Math.max(this.dirty.y1, rect.y1);
  }

  _settle(dt) {
    const cfg = experience.settle;
    if (!cfg.enabled || !this.height) return;
    if (this.drawing) return;
    if (performance.now() - this.lastInteractAt < cfg.idleDelayMs) return;

    this.settleAcc += dt;
    if (this.settleAcc < 2.5) return;
    const elapsed = this.settleAcc;
    this.settleAcc = 0;

    const amount = cfg.ratePerSecond * elapsed;
    if (amount <= 0) return;

    const h = this.height;
    let maxDelta = 0;
    for (let i = 0; i < h.length; i++) {
      const v = h[i];
      const nv = v + (0.5 - v) * amount;
      const d = Math.abs(nv - v);
      if (d > maxDelta) maxDelta = d;
      h[i] = nv;
    }
    if (maxDelta > 0.0004) this.needsFullRender = true;
  }

  _loop(now) {
    if (!this.running) return;

    // Catch iOS address-bar / rotation size changes that miss resize events
    this._resizeCheckAcc = (this._resizeCheckAcc || 0) + 1;
    if (this._resizeCheckAcc % 45 === 0) {
      const parent = this.canvas.parentElement || this.canvas;
      const rect = parent.getBoundingClientRect();
      const w = Math.round(rect.width);
      const h = Math.round(rect.height);
      if (w > 0 && h > 0 && (w !== this.cssW || h !== this.cssH)) {
        this.resize();
      }
    }

    if (!this._lastTs) this._lastTs = now;
    const dt = Math.min(0.05, (now - this._lastTs) / 1000);
    this._lastTs = now;

    this._settle(dt);

    if (this.needsFullRender) {
      this._renderFull();
      this.needsFullRender = false;
      this.dirty = null;
    } else if (this.dirty) {
      this._renderRegion(this.dirty);
      this.dirty = null;
    }

    this.rafId = requestAnimationFrame(this._loop);
  }

  _lightNormal(x, y) {
    const { height, pxW, pxH } = this;
    const xm = Math.max(0, x - 1);
    const xp = Math.min(pxW - 1, x + 1);
    const ym = Math.max(0, y - 1);
    const yp = Math.min(pxH - 1, y + 1);
    const dx = height[y * pxW + xp] - height[y * pxW + xm];
    const dy = height[yp * pxW + x] - height[ym * pxW + x];
    const nx = -dx * 3.2;
    const ny = -dy * 3.2;
    const nz = 1;
    const inv = 1 / Math.hypot(nx, ny, nz);
    return { nx: nx * inv, ny: ny * inv, nz: nz * inv };
  }

  _shadeSandPixel(x, y) {
    const { grain, height, pxW } = this;
    const i3 = (y * pxW + x) * 3;
    let r = grain[i3];
    let g = grain[i3 + 1];
    let b = grain[i3 + 2];

    const h = height[y * pxW + x];
    const groove = Math.abs(h - 0.5);
    // Mild grit pop in the furrow — avoid pushing light grains to white
    if (groove > 0.012) {
      const mid = hexToRgb(palette.sandMid);
      const boost = 1 + groove * 1.15;
      r = mid.r + (r - mid.r) * boost;
      g = mid.g + (g - mid.g) * boost;
      b = mid.b + (b - mid.b) * boost;
    }

    const { nx, ny, nz } = this._lightNormal(x, y);
    const lx = lighting.lx;
    const ly = lighting.ly;
    const lz = 0.55;
    const invL = 1 / Math.hypot(lx, ly, lz);
    const ndotl = clamp(nx * lx * invL + ny * ly * invL + nz * lz * invL, 0, 1);

    // Furrows deepen toward sandDark; ridges warm toward sandWarm (not white)
    const warm = hexToRgb(palette.sandWarm || palette.sandLight);
    const dark = hexToRgb(palette.sandDark);
    const trenchAmt = clamp((0.5 - h) * 2.2, 0, 1);
    const ridgeAmt = clamp((h - 0.5) * 2.4, 0, 1);

    const shade = 0.7 + ndotl * 0.38;
    r *= shade;
    g *= shade;
    b *= shade;

    r = r + (dark.r - r) * trenchAmt * 0.55;
    g = g + (dark.g - g) * trenchAmt * 0.52;
    b = b + (dark.b - b) * trenchAmt * 0.45;

    r = r + (warm.r - r) * ridgeAmt * 0.4;
    g = g + (warm.g - g) * ridgeAmt * 0.38;
    b = b + (warm.b - b) * ridgeAmt * 0.3;

    // Soft luminance cap — keep marks in sand range
    const lum = 0.299 * r + 0.587 * g + 0.114 * b;
    if (lum > 230) {
      const s = 230 / lum;
      r *= s;
      g *= s;
      b *= s;
    }

    return {
      r: clamp(r, 0, 255),
      g: clamp(g, 0, 255),
      b: clamp(b, 0, 255),
    };
  }

  _shadePixel(x, y) {
    const cssX = x / this.dpr;
    const cssY = y / this.dpr;

    // Soft contact shadow under stone footprints (sprites drawn on top after)
    for (const s of this.stones) {
      const d = dist(cssX, cssY, s.x, s.y);
      if (d < s.r * 1.2 && d >= s.r * 0.78) {
        const sand = this._shadeSandPixel(x, y);
        const t = 1 - (d - s.r * 0.78) / (s.r * 0.42);
        const shadow = t * t * 48;
        return {
          r: clamp(sand.r - shadow, 0, 255),
          g: clamp(sand.g - shadow * 0.95, 0, 255),
          b: clamp(sand.b - shadow * 0.85, 0, 255),
        };
      }
      // Leave stone body to sprite pass — don't paint procedural rock into sand buffer
      if (d < s.r * 0.78) {
        return this._shadeSandPixel(x, y);
      }
    }

    return this._shadeSandPixel(x, y);
  }

  _drawStoneSprites() {
    const { ctx, dpr } = this;
    if (!this._stoneImages) return;

    for (const s of this.stones) {
      const img = s.image ? this._stoneImages.get(s.image) : null;
      ctx.save();
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      // Soft multi-layer contact shadow (~6–10px sit-in-sand)
      ctx.beginPath();
      ctx.ellipse(
        s.x + s.r * 0.08,
        s.y + s.r * 0.2,
        s.r * 1.02,
        s.r * 0.48,
        0,
        0,
        Math.PI * 2
      );
      ctx.fillStyle = 'rgba(52, 40, 28, 0.14)';
      ctx.fill();
      ctx.beginPath();
      ctx.ellipse(
        s.x + s.r * 0.06,
        s.y + s.r * 0.16,
        s.r * 0.88,
        s.r * 0.36,
        0,
        0,
        Math.PI * 2
      );
      ctx.fillStyle = 'rgba(52, 40, 28, 0.2)';
      ctx.fill();

      if (img && img.complete && img.naturalWidth > 0) {
        // Contain inside a square so phone layout never squashes the pebble
        const maxDim = s.r * 2;
        const aspect = img.naturalWidth / img.naturalHeight;
        let w;
        let h;
        if (aspect >= 1) {
          w = maxDim;
          h = maxDim / aspect;
        } else {
          h = maxDim;
          w = maxDim * aspect;
        }
        ctx.shadowColor = 'rgba(40, 30, 22, 0.18)';
        ctx.shadowBlur = 8;
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 4;
        ctx.drawImage(img, s.x - w / 2, s.y - h / 2, w, h);
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
      }

      ctx.restore();
    }
  }

  _renderFull() {
    const { ctx, pxW, pxH } = this;
    const img = ctx.createImageData(pxW, pxH);
    const data = img.data;
    for (let y = 0; y < pxH; y++) {
      for (let x = 0; x < pxW; x++) {
        const { r, g, b } = this._shadePixel(x, y);
        const i = (y * pxW + x) * 4;
        data[i] = r;
        data[i + 1] = g;
        data[i + 2] = b;
        data[i + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    this._drawStoneSprites();
  }

  _renderRegion(region) {
    const { ctx } = this;
    const w = region.x1 - region.x0 + 1;
    const h = region.y1 - region.y0 + 1;
    if (w <= 0 || h <= 0) return;
    const img = ctx.createImageData(w, h);
    const data = img.data;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const { r, g, b } = this._shadePixel(region.x0 + x, region.y0 + y);
        const i = (y * w + x) * 4;
        data[i] = r;
        data[i + 1] = g;
        data[i + 2] = b;
        data[i + 3] = 255;
      }
    }
    ctx.putImageData(img, region.x0, region.y0);
    // Resample sand under stones, then paint sprites once (avoids stacked shadows)
    this._refreshStoneFootprints();
  }

  _refreshStoneFootprints() {
    const { ctx, dpr, pxW, pxH } = this;
    for (const s of this.stones) {
      const pad = s.r * 1.4;
      const x0 = clamp(Math.floor((s.x - pad) * dpr), 0, pxW - 1);
      const y0 = clamp(Math.floor((s.y - pad) * dpr), 0, pxH - 1);
      const x1 = clamp(Math.ceil((s.x + pad) * dpr), 0, pxW - 1);
      const y1 = clamp(Math.ceil((s.y + pad * 1.15) * dpr), 0, pxH - 1);
      const w = x1 - x0 + 1;
      const h = y1 - y0 + 1;
      if (w <= 0 || h <= 0) continue;
      const img = ctx.createImageData(w, h);
      const data = img.data;
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          const { r, g, b } = this._shadePixel(x0 + x, y0 + y);
          const i = (y * w + x) * 4;
          data[i] = r;
          data[i + 1] = g;
          data[i + 2] = b;
          data[i + 3] = 255;
        }
      }
      ctx.putImageData(img, x0, y0);
    }
    this._drawStoneSprites();
  }
}


/* ===== ui.js ===== */
/**
 * UI chrome — sidebar copy, wooden tool dock, sound toggle, smooth, custom cursor.
 */

/**
 * @param {object} opts
 * @param {(id: string) => void} opts.onToolChange
 * @param {() => void} opts.onShake
 * @param {() => Promise<boolean>|boolean} opts.onSoundToggle
 * @param {(size: number) => void} [opts.onBrushSize]
 */
function initUI({ onToolChange, onShake, onSoundToggle, onBrushSize }) {
  const dock = document.getElementById('tool-dock');
  const soundBtn = document.getElementById('sound-toggle');
  const shakeBtn = document.getElementById('shake-table');
  const cta = document.getElementById('enter-cta');
  const canvas = document.getElementById('sand-canvas');
  const garden = document.getElementById('garden');
  const eyebrow = document.getElementById('panel-eyebrow');
  const brandEl = document.getElementById('panel-brand');
  const practice = document.getElementById('panel-practice');
  const directions = document.getElementById('panel-directions');
  const sizeBar = document.getElementById('size-bar');
  const sizeSlider = document.getElementById('size-slider');
  const sizePreview = document.getElementById('size-preview');
  const infoTab = document.getElementById('info-tab');
  const infoSheet = document.getElementById('info-sheet');
  const sheetClose = document.getElementById('sheet-close');

  document.title = brand.name;
  if (eyebrow) eyebrow.textContent = brand.eyebrow;
  if (brandEl) brandEl.textContent = brand.name;
  if (practice) practice.textContent = brand.practice;
  if (directions) directions.textContent = brand.directions;
  if (shakeBtn) shakeBtn.textContent = brand.smoothLabel;

  if (cta) {
    cta.textContent = brand.ctaLabel;
    const href =
      (typeof window !== 'undefined' &&
        window.ZEN_ASSETS &&
        window.ZEN_ASSETS.enterUrl) ||
      brand.ctaHref;
    if (href) cta.href = href;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const delay = coarse ? 0 : experience.ctaDelayMs;
    window.setTimeout(() => {
      cta.classList.add('is-visible');
      shakeBtn?.classList.add('is-visible');
    }, delay);
  } else {
    shakeBtn?.classList.add('is-visible');
  }

  // Mobile Practice sheet
  let backdrop = document.querySelector('.sheet-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'sheet-backdrop';
    document.body.appendChild(backdrop);
  }

  function setSheetOpen(open) {
    if (!infoSheet || !infoTab) return;
    infoSheet.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    infoTab.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  infoTab?.addEventListener('click', () => {
    const open = infoTab.getAttribute('aria-expanded') !== 'true';
    setSheetOpen(open);
  });
  sheetClose?.addEventListener('click', () => setSheetOpen(false));
  backdrop.addEventListener('click', () => setSheetOpen(false));

  /** @type {string} */
  let activeId = tools[0].id;
  const buttons = new Map();

  const cursor = document.createElement('div');
  cursor.className = 'rake-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  document.body.appendChild(cursor);

  const brushCfg = experience.brushSize || { min: 0.7, max: 2.2, default: 1.35 };
  let brushSize = brushCfg.default;

  function sliderToSize(raw) {
    const t = (Number(raw) - 70) / (220 - 70);
    return brushCfg.min + clamp01(t) * (brushCfg.max - brushCfg.min);
  }

  function sizeToSlider(size) {
    const t = (size - brushCfg.min) / (brushCfg.max - brushCfg.min);
    return Math.round(70 + clamp01(t) * (220 - 70));
  }

  function clamp01(n) {
    return Math.max(0, Math.min(1, n));
  }

  function applyBrushSize(size, { syncSlider = false } = {}) {
    brushSize = size;
    onBrushSize?.(size);
    if (sizePreview) {
      const px = 8 + ((size - brushCfg.min) / (brushCfg.max - brushCfg.min)) * 22;
      sizePreview.style.setProperty('--preview', `${px.toFixed(1)}px`);
    }
    cursor.style.width = `${Math.round(88 * size)}px`;
    if (syncSlider && sizeSlider) sizeSlider.value = String(sizeToSlider(size));
  }

  const isCoarse = window.matchMedia('(pointer: coarse)').matches;
  const isNarrow = window.matchMedia('(max-width: 767px)').matches;
  if (sizeBar && !isCoarse && !isNarrow) {
    sizeBar.hidden = false;
    if (sizeSlider) {
      sizeSlider.value = String(sizeToSlider(brushCfg.default));
      const emit = () => applyBrushSize(sliderToSize(sizeSlider.value));
      sizeSlider.addEventListener('input', emit);
      sizeSlider.addEventListener('change', emit);
    }
    applyBrushSize(brushCfg.default, { syncSlider: true });
  } else {
    applyBrushSize(1);
  }

  function updateCursorIcon(id) {
    const tool = tools.find((t) => t.id === id) || tools[0];
    cursor.innerHTML = `<img src="${tool.image}" alt="" draggable="false" />`;
  }

  for (const tool of tools) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tool-btn';
    btn.dataset.tool = tool.id;
    btn.setAttribute('aria-label', tool.label);
    btn.title = tool.label;
    btn.innerHTML = `<img src="${tool.image}" alt="" draggable="false" />`;
    btn.addEventListener('click', () => selectTool(tool.id));
    dock.appendChild(btn);
    buttons.set(tool.id, btn);
  }

  function selectTool(id) {
    activeId = id;
    for (const [tid, el] of buttons) {
      el.classList.toggle('is-active', tid === id);
    }
    onToolChange(id);
    updateCursorIcon(id);
  }

  selectTool(activeId);

  soundBtn?.addEventListener('click', async (e) => {
    e.preventDefault();
    try {
      const enabled = await onSoundToggle();
      soundBtn.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    } catch {
      soundBtn.setAttribute('aria-pressed', 'false');
    }
  });

  shakeBtn?.addEventListener('click', () => {
    garden?.classList.remove('is-shaking');
    void garden?.offsetWidth;
    garden?.classList.add('is-shaking');
    onShake();
    setSheetOpen(false);
    window.setTimeout(() => garden?.classList.remove('is-shaking'), 700);
  });

  let cursorVisible = false;

  function showCursor(show) {
    if (isCoarse) return;
    cursorVisible = show;
    cursor.classList.toggle('is-visible', show);
  }

  canvas.addEventListener('pointerenter', (e) => {
    if (e.pointerType === 'mouse') showCursor(true);
  });
  canvas.addEventListener('pointerleave', () => showCursor(false));
  window.addEventListener('pointermove', (e) => {
    if (!cursorVisible || e.pointerType !== 'mouse') return;
    cursor.style.left = `${e.clientX}px`;
    cursor.style.top = `${e.clientY}px`;
  });

  return {
    getActiveToolId: () => activeId,
    getBrushSize: () => brushSize,
    selectTool,
  };
}


/* ===== main.js ===== */
/**
 * Bootstrap — wires sand engine, tools, UI, and audio.
 */

const canvas = document.getElementById('sand-canvas');
const audio = new GardenAudio();

const engine = new SandEngine(canvas, {
  onRake(speed) {
    audio.scrape(speed);
  },
});

const ui = initUI({
  onToolChange(id) {
    engine.setTool(id);
  },
  onBrushSize(size) {
    engine.setBrushSize(size);
  },
  onShake() {
    engine.shake();
  },
  async onSoundToggle() {
    return audio.toggle();
  },
});

engine.setTool(ui.getActiveToolId());
engine.setBrushSize(ui.getBrushSize());
engine.mount();

// iOS: unlock / keep AudioContext alive on first garden touch
canvas?.addEventListener(
  'pointerdown',
  () => {
    audio.unlock();
    if (audio.enabled) audio.unlock();
  },
  { passive: true }
);

let resizeTimer = 0;
const scheduleResize = () => {
  window.clearTimeout(resizeTimer);
  resizeTimer = window.setTimeout(() => engine.resize(), 80);
};
window.addEventListener('resize', scheduleResize);
window.addEventListener('orientationchange', scheduleResize);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', scheduleResize);
}

document.addEventListener(
  'gesturestart',
  (e) => {
    e.preventDefault();
  },
  { passive: false }
);

  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
